// The words of the System states (spec C7; the "Sign in and system states" board, states 14 to 17).
// Lines marked "proposed" are not on the board.
import { managesDepartment, type Role } from '../roles';

export const systemCopy = {
  notFoundTitle: 'We could not find that page.',
  notFoundLine: 'The link may be old or typed wrong.',
  noAccessTitle: 'No access',
  noAccessRecord: 'This renewal is assigned to someone else. Ask your manager if you need it.',
  serverTitle: 'Something went wrong on our side. Try again in a minute.',
  serverLine: (ref: string | null) =>
    ref ? `The admin was notified. Error reference ${ref}.` : 'The admin was notified.',
  tryAgain: 'Try again',
  tryingAgain: 'Trying again...',
  stillFailing: 'Still not working. Try again in a minute.',
  offline: 'You are offline. Changes will not save until you are back online.',
  checking: 'Checking...',
  stillOffline: 'Still offline. Check your connection.',
} as const;

/** Where the system cards send you back to: the Manager and the Admin to All renewals. */
export const backTo = (role: Role) =>
  managesDepartment(role)
    ? { to: '/renewals/all', label: 'Back to All renewals' }
    : { to: '/renewals/my', label: 'Back to My renewals' };
